// extracted by mini-css-extract-plugin
export default {"poweredRow":"Footer_poweredRow__dANsu"};